<div id="dialog-container">
  <h1 mat-dialog-title>{{ 'TITLE.RENEW_CONTRACT' | translate }}</h1>

  <mat-divider></mat-divider>

  @if (missingRequiredFields$ | async; as missingRequiredFields) {
    @if (missingRequiredFields.length > 0) {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
        <ul>
          @for (field of missingRequiredFields; track field.code) {
            <li>{{ field.label }}</li>
          }
        </ul>
      </mat-dialog-content>
      <mat-dialog-actions class="center">
        <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
      </mat-dialog-actions>
    } @else {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <div class="form-container">
          <form [formGroup]="contractForm">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'LABEL.CONTRACT_PROVIDER' | translate }}</mat-label>
              <input matInput [id]="'renew_contract_provider'" formControlName="provider" required/>
            </mat-form-field>

            @if (assetTypeAllowsSpaceModule) {
              <div class="space-form-field">
                <div class="ag-grid-container">
                  <ag-grid-angular
                    (gridReady)="onGridReady($event)"
                    [gridOptions]="gridOptions"
                    class="ag-theme-material"
                    id="renew-contract-allocated-spaces-grid">
                  </ag-grid-angular>
                </div>

                @if (contractForm.controls.spaces.touched && contractForm.controls.spaces.hasError('required')) {
                  <mat-error>
                    {{ 'ERROR.FIELD_REQUIRED' | translate }}
                  </mat-error>
                }

                @if (contractForm.controls.spaces.hasError('incoherentSpaces')) {
                  <mat-error>
                    {{ 'ERROR.SPACES_INCOHERENT' | translate }}
                  </mat-error>
                }
              </div>
            }
          </form>

          <div class="button-container fx-layout-row fx-justify-end fx-align-center">
            <button mat-stroked-button matDialogClose="cancel" [id]="'create-contract-cancel-button'">
              {{ 'BUTTON.CANCEL' | translate }}
            </button>

            <button [disabled]="!contractForm.valid"
                    [id]="'renew-contract-add-button'"
                    color="accent"
                    mat-raised-button
                    matDialogClose="yes">
              {{ 'BUTTON.RENEW' | translate }}
            </button>
          </div>
        </div>
      </mat-dialog-content>
    }
  } @else {
    <spinner></spinner>
  }
</div>
